import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';

import { FieldsetModule } from 'primeng/fieldset';
import { MessageModule } from 'primeng/message';
import { TooltipModule } from 'primeng/tooltip';

import { MediaSubscriptionComponent } from './components/MediaSubscription/media-subscription.component';
import { LocalizationModule } from '../../Core/Localization/localization.module';
import { MiscModule } from '../../Common/Misc/misc.module';
import { MonitorSharedModule } from '../Shared/monitoring-shared.module';
import { SubscriptionDashboardComponent } from './components/SubscriptionDashboard/subscription-dashboard.component';
import { ChartsModule } from '../../Common/Charts/charts.module';
import { CommonFormsModule } from '../../Common/Forms/forms.module';
import { LayoutModule } from '../../Common/Layout/layout.module';
import { CommonBasicModule } from '../../Common/Basic/basic.module';
import { BackfillDialogComponent } from './components/BackfillDialog/backfill-dialog.component';
import { CoreDialogsModule } from '../../Core/Dialogs/dialogs.module';
import { CommonDialogsModule } from '../../Common/Dialogs/common-dialogs.module';

import { MentionsModule } from '../../Common/Mentions/mentions.module';
import { SocialSharedModule } from '../../Social/Shared/social-shared.module';

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        FieldsetModule,
        MessageModule,
        LocalizationModule,
        MiscModule,
        MonitorSharedModule,
        ChartsModule,
        CommonFormsModule,
        RouterModule,
        LayoutModule,
        TooltipModule,
        CommonBasicModule,
        CoreDialogsModule,
        CommonDialogsModule,
        MentionsModule,
        SocialSharedModule
    ],
    declarations: [
        MediaSubscriptionComponent,
        SubscriptionDashboardComponent,
        BackfillDialogComponent
    ],
    exports: [
        MediaSubscriptionComponent,
        SubscriptionDashboardComponent
    ]
})
export class MediaSubscriptionsModule {}
